import { contactInfo } from '../data/contactInfo';

export const sendToWhatsApp = (formData) => {
  const phoneNumber = contactInfo.phone.primaryLink; // Uses centralized phone number
  
  const message = `
*New Inquiry from AKY Legal Website*
------------------------------------
*Name:* ${formData.name}
*Email:* ${formData.email}
*Phone:* ${formData.phone}
*Query:* 
${formData.query}
------------------------------------
*Submitted from:* Website Contact Form
  `.trim();

  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  
  window.open(whatsappUrl, '_blank');
};